import React from "react"
import PropTypes from "prop-types"
import PageSection from "../PageSection"

const CourseList = ({ title, children }) => (
  <PageSection className="courses" title={title}>
    {children}
  </PageSection>
)

CourseList.propTypes = {
  title: PropTypes.string,
}

CourseList.defaultProps = {
  title: ``,
}

export default CourseList;